define(['components/utilities/utilities', 'components/loader/loader', 'components/pubsub/pubsub', 'libs/nanoajax'], function (utils, loader, pubsub, nanoajax) {
	'use strict';

	/**
	 * Load more
	 * A plugin that implements a "load more" pagination, with url updates and back-button support.
	 * @see {@link http://tumbledry.org/2011/05/12/screw_hashbangs_building}
	 * @version 1.1.1
	 * @exports loadMore
	 */
	var loadMore = {

		/** Placeholder for base DOM element. */
		el: null,

		/** Placeholder for template (used if this plugin is used with json). */
		template: null,

		/** Target DOM id (the list). */
		targetId: null,

		/** Placeholder for target DOM element (the list). */
		targetEl: null,

		/** Boolean to indicate if there are any ajax-request in progress. */
		requestInProgress: false,

		/** 1 = DOESN'T WORK CORRECTLY RIGHT NOW. back button navigates WITHIN the page. 0 = back button navigates to previous, referring page. */
		supportBackButton: 0,

		/** Placeholder to contain the starting page (so url can display page=1-3). */
		urlCarryPageBase: null,

		/** Array that will contain the loaded pages. */
		itemCount: [],

		/** Selector for items. */
		itemSelector: 'article',


		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function (el) {
			var that = this;

			if (!utils.hasHistorySupport()) {
				return false;
			}

			if (el !== undefined) {
				this.el = el;
			} else {
				this.el = document.querySelector('[data-type="loadMore"]');
			}

			this.targetId = el.getAttribute('aria-controls');
			this.targetEl = document.getElementById(this.targetId);

			if (this.targetEl === null) {
				return false;
			}

			if (el.getAttribute('data-itemselector') !== null) {
				this.itemSelector = el.getAttribute('data-itemselector');
			}

			if (el.getAttribute('data-template') !== null) {
				require(['../../templates/' + el.getAttribute('data-template') + '.hbs'], function (tpl) {
					that.template = tpl;
					that._initEvents();
				});
			} else {
				this._initEvents();
			}
		},


		/**
		 * Function that loads next page through ajax.
		 * @private
		 */
		_load: function () {
			var that = this,
				url = this.el.getAttribute('href'),
				loadingMessage = this.el.getAttribute('data-loading-message') || 'Laddar';

			if (this.requestInProgress === false && this._pathchange(url)) {
				this.requestInProgress = true;
				loader.loadingStart(this.el, loadingMessage, '', true);

				nanoajax.ajax({
					method: 'GET',
					headers: {
						'x-requested-with': 'XMLHttpRequest'
					},
					url: utils.updateURLParameter(url, '_', utils.getTimestamp())
				},
				function (code, responseText, request) {
					if (code === 200) {
						var ct = request.getResponseHeader('content-type') || '';

						if (ct.indexOf('html') > -1) {
							that._renderHtml(responseText);
						}
						else if (ct.indexOf('json') > -1) {
							that._renderJson(responseText);
						}

						that.requestInProgress = false;
						loader.loadingEnd(that.el);
					}
				});
			}
		},


		/**
		 * Function that renders new html-data.
		 * @param {String} data - New data as a string of html.
		 * @private
		 */
		_renderHtml: function (data) {
			var parser = new DOMParser(),
				doc = parser.parseFromString(data, 'text/html'),
				newPager, newItems;

			newPager = doc.querySelector('[data-type="loadMore"]');
			newItems = doc.querySelectorAll('#' + this.targetId + ' ' + this.itemSelector);

			for (var i = 0; i < newItems.length; i++) {
				this.targetEl.appendChild(newItems[i]);

				if (i === 0) {
					var firstLink = newItems[i].querySelector('a');

					if (firstLink !== null) {
						firstLink.focus();
					} else {
						newItems[i].focus();
					}
				}
			}

			this.itemCount.push(newItems.length);

			if (newPager === null) {
				if (this.el.remove) {
					this.el.remove();
				} else {
					this.el.parentNode.removeChild(this.el);
				}
			} else {
				this.el.setAttribute('href', newPager.getAttribute('href'));
			}
			pubsub.publish('/ajaxForm/list/updated');
		},


		/**
		 * Function that renders new json-data.
		 * @param {String} data - New data as a string of json.
		 * @private
		 */
		_renderJson: function (data) {
			var html = '',
				oldItems = null,
				newItems = null,
				firstLink;

			try {
				data = JSON.parse(data);
				html = this.template(data);
			} catch (e) {}

			if (data.pagerUrl === undefined || data.pagerUrl === null || data.pagerUrl === '') {
				utils.addClass(this.el, 'is-hidden');
			} else {
				utils.removeClass(this.el, 'is-hidden');
				this.el.setAttribute('href', data.pagerUrl);
			}

			oldItems = this.targetEl.querySelectorAll(this.itemSelector);
			this.targetEl.insertAdjacentHTML('BeforeEnd', html);
			newItems = this.targetEl.querySelectorAll(this.itemSelector);
			this.itemCount.push(newItems.length - oldItems.length);

			if (newItems[oldItems.length] !== null) {
				firstLink = newItems[oldItems.length].querySelector('a');
				if (firstLink !== null) {
					firstLink.focus();
				} else {
					newItems[oldItems.length].focus();
				}
			}
			pubsub.publish('/ajaxForm/list/updated');
		},


		/**
		 * Function that updates the url.
		 * @private
		 */
		_pathchange: function (path) {
			var regexp = /\/pages?\/([0-9]+)-?[0-9]*\/?$/,
				locationHref = window.location.href,
				basePath = path,
				nextPage;

			// Query-based
			if (path.indexOf('?page=') !== -1 || path.indexOf('&page=') !== -1) {
				this.queryBased = true;
				regexp = /pages?=([0-9]+)-?[0-9]*\/?$/;
			}
			else if (path.indexOf('?') !== -1) {
				basePath = path.split('?')[0];
			}

			if (locationHref.indexOf('?') !== -1 && (locationHref.indexOf('?page=') === -1 && locationHref.indexOf('&page=') === -1)) {
				locationHref = locationHref.split('?')[0];
			}

			if (this.urlCarryPageBase === null) {
				if (regexp.test(locationHref)) {
					nextPage = regexp.exec(locationHref);
					this.urlCarryPageBase = nextPage[1];
				} else {
					nextPage = regexp.exec(basePath);
					this.urlCarryPageBase = nextPage[1] - 1;
				}
			}

			if (this.queryBased === true) {
				path = path.replace('page=', 'pages=' + this.urlCarryPageBase + '-');
			} else {
				path = path.replace('page/', 'pages/' + this.urlCarryPageBase + '-');
			}

			if (this.supportBackButton === 1) {
				window.history.pushState(null, null, utils.updateURLParameter(path, '_', utils.getTimestamp()));
			} else {
				window.history.replaceState(null, null, utils.updateURLParameter(path, '_', utils.getTimestamp()));
			}

			return true;
		},


		/**
		 * Initiates events.
		 * @private
		 */
		_initEvents: function () {
			var that = this;

			utils.addEventListener(this.el, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

				that._load();
			});

			if (that.supportBackButton === 1) {
				window.onpopstate = function () {
					var lastTime, items;

					if (that.supportBackButton === 1) {
						items = that.targetEl.querySelectorAll(that.itemSelector);

						if (that.itemCount.length > 0) {
							lastTime = that.itemCount.pop();
						}

						for (var i = 1; i <= lastTime; i++) {
							that.targetEl.removeChild(items[items.length - i ]);
						}
					}
				};
			}
		}
	};


	return loadMore;
});


//////////////////
// WEBPACK FOOTER
// ./components/loadMore/loadMore.js
// module id = 24
// module chunks = 8